"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckTeamGuard = void 0;
// common guard functionality
function CheckTeamGuard(groups, params) {
    // make sure user has group permission to transition
    const groupIds = (params === null || params === void 0 ? void 0 : params.groupIds) || [];
    return groups.some(group => groupIds.some(id => id === group.id));
}
exports.CheckTeamGuard = CheckTeamGuard;
//# sourceMappingURL=CheckTeamPlugin.js.map